import * as MEDICINE from '@/store/constants/medicine';
import {mapActions} from 'vuex';

import ListHeaderTitle from '@/views/Common/ListHeaderTitle';
import Notification from '@/views/Common/Notification';

import NotificationMixin from '@/mixins/notification';

export default {
  name: "MedicineAdd",
  inject: ['$validator'],
  data() {
    return {
      medicine: {},
      action: 'add',
    }
  },
  components: {ListHeaderTitle, Notification},
  mixins: [NotificationMixin],
  methods: {
    ...mapActions({
      addMedicine: MEDICINE.ACTION_ADD,
      updateMedicine: MEDICINE.ACTION_UPDATE
    }),

    handleUpdate() {
      this.updateMedicine(this.medicine).then((res) => {
        this.showSuccessNotification('Medicine record successfully updated.');
      })
    },

    handleAdd() {
      this.addMedicine(this.medicine).then(res => {
        this.showSuccessNotification('Medicine record successfully added.');
        this.reset();
      }).catch(e => {
        this.showErrorNotification(e.response.data.message);
      })
    },

    save() {
      this.$validator.validateAll().then(res => {
        if (res) (this.action === 'edit') ? this.handleUpdate() : this.handleAdd();
      }).catch(e => {
        this.showErrorNotification(e.response.data.message);
      })
    },

    reset() {
      this.medicine = {};
      this.$validator.reset()
    }
  },
  created() {
    if (this.$route.params['medicine']) {
      this.medicine = this.$route.params['medicine'];
      this.action = 'edit';
    } else {
      this.action = 'add';
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Medicine/js/form-add-edit.js